import { useCallback } from "react";
import { businessMatchingCurrentBusinessEntityPath } from "../../../../../routes";
import useRequest from "../../../shared/lib/useRequest";

export const useSetCurrentBusinessEntityCode = () => {
  const request = useRequest();

  const setCurrentBusinessEntityCode = useCallback(async (code: string) => {
    const res = await request(
      businessMatchingCurrentBusinessEntityPath(),
      "PUT",
      {
        code: code,
      },
    );

    if (res.ok) {
      await (res.json() as Promise<{ redirect_url: null | string }>).then(
        (json) => {
          if (json.redirect_url != null) {
            location.href = json.redirect_url;
          } else {
            location.reload();
          }
        },
      );
    }
  }, [request]);

  return setCurrentBusinessEntityCode;
};
